import { createRef, h, Fragment } from "preact";
import { useLayoutEffect, useState } from "preact/hooks";

import Icon from "./Icon.jsx";
import List from "./List.jsx";
import ListItem from "./ListItem.jsx";
import Overlay from "./Overlay.jsx";

import i18n from "../i18n";

export default function DirectShareDialog({
  copyText,
  trigger,
  mailBody,
  mailSubject,
  onClose,
  onOpen,
}) {
  const dialogRef = createRef();
  const overlayRef = createRef();
  const [showCopyNote, setShowCopyNote] = useState(false);

  function handleCopyClick() {
    navigator.clipboard.writeText(copyText);
    clearTimeout(showCopyNote);
    setShowCopyNote(setTimeout(onClose, 1000));
  }
  console.log("mailSubject", mailSubject);

  useLayoutEffect(() => {
    // TODO: Some of this stuff should belong to Overlay and some should go into a
    //       general Dialog component
    const overlay = overlayRef.current.base;
    overlay.classList.add("overlay--open");
    const wrapper = dialogRef.current;
    wrapper.classList.add("dialog--open");
    wrapper.addEventListener(
      "animationend",
      () => {
        onOpen && onOpen();
      },
      { once: true } // Does not work in IE, but who cares
    );

    return () => {
      overlay.classList.add("overlay--exit");
      wrapper.classList.add("dialog--exit");

      return new Promise(function (resolve) {
        wrapper.addEventListener("animationend", resolve);
      });
    };
  }, []);

  function handleMailClick() {
    window.open(
      `mailto:?subject=${encodeURIComponent(
        mailSubject || ""
      )}&body=${encodeURIComponent(mailBody || "")}`,
      "_blank"
    );
    onClose();
  }

  const box = trigger.getBoundingClientRect();

  const style = {
    position: "absolute",
    top: box.top + trigger.offsetHeight + "px",
    left: box.left + "px",
  };

  return (
    <Overlay transparent onClick={onClose} ref={overlayRef}>
      <section
        class="dialog dialog--sm dialog--slim card"
        style={style}
        ref={dialogRef}
      >
        <List>
          <ListItem
            iconFront={<Icon>link</Icon>}
            onClick={() => handleCopyClick()}
          >
            {i18n.t(
              showCopyNote
                ? `component.direct_share_dialog.copied`
                : `component.direct_share_dialog.copy`
            )}
          </ListItem>

          <ListItem
            iconFront={<Icon>mail_small</Icon>}
            onClick={() => handleMailClick()}
          >
            {i18n.t(`component.direct_share_dialog.email`)}
          </ListItem>
        </List>
      </section>
    </Overlay>
  );
}
